import { render, staticRenderFns } from "./team-insights-group-results.vue?vue&type=template&id=50414c4a&"
import script from "./team-insights-group-results.ts?vue&type=script&lang=js&"
export * from "./team-insights-group-results.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports